import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {store} from './store'
import router from './router'
import './registerServiceWorker'
import './plugins/mbs_components'
import './plugins/views_components'
import './plugins/external_imports'
import './plugins/firebase'
import './plugins/main.css'
import formatNumber from './plugins/formatNumber';
import DATA from './plugins/DATA';


import {EventBus} from './plugins/eventBus' 
import {NetworkEventBus} from './plugins/networkEventBus' 
import {ActionBus} from './plugins/actionBus' 
import {EisBus} from './plugins/eisBus' 
import {DataBus} from './plugins/dataBus' 
import {TextBus} from './plugins/textBus' 
import {DateBus} from './plugins/dateBus' 
import {OrderProcessorBus}  from './plugins/process/orderProcessor.plugin'
// import bluetoothPrinterBus  from './plugins/process/bluetoothPrinter.plugin.js'

 
Vue.config.productionTip = false
Vue.mixin({
  data() {
    return {
      toNumber:formatNumber.toNumber,
      MBS: {
        events:EventBus, 
        networkEvents:NetworkEventBus, 
        actions:ActionBus,
        eis:EisBus,
        data:DataBus,
        DATA:DATA,
        color:DataBus.color,
        text:TextBus,
        date:DateBus,
        orderProcessor: OrderProcessorBus,
        // bluetoothPrinter: bluetoothPrinterBus,
      }
    }
  },
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
